module.exports = __webpack_public_path__ + "files/c212e0222b20dcb1847ccd32ee419a1c.ttf";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/sourcesanspro-italic-webfont.ttf
// module id = 779
// module chunks = 60